import type {TextSectionFragmentType} from '@/modules/page/sanity/content-blocks/text-container/query';

import {LINK_FRAGMENT} from '../../link/query';

export const CALL_TO_ACTION_FRAGMENT = `//groq
	...,
	${LINK_FRAGMENT}
`;

export type CallToActionLineFragment = Extract<
	NonNullable<TextSectionFragmentType['content']>[number],
	{_type: 'callToActionLine'}
>;

export const CALL_TO_ACTION_LINE_FRAGMENT = `//groq
	_type == "callToActionLine" => {
		...,
		callToActions[] {
			...,
			${CALL_TO_ACTION_FRAGMENT}
		}
	}
`;
